import { OktaAuth } from '@okta/okta-auth-js';
import { getActiveIDPConfig } from './idpConfig';
import logger from '../utils/logger';

const idpConfig = getActiveIDPConfig();

if (!idpConfig.issuer || !idpConfig.clientId) {
  logger.error('[OKTA-CONFIG] Missing required Okta configuration:', {
    issuer: idpConfig.issuer,
    clientId: idpConfig.clientId,
    fullConfig: idpConfig
  });
  throw new Error('Missing required Okta configuration. Please check your environment variables.');
}

// Ensure issuer has the authorization server path
let issuer = idpConfig.issuer;
if (issuer && !issuer.includes('/oauth2/')) {
  issuer = `${issuer}/oauth2/default`;
  logger.debug('[OKTA-CONFIG] Added default authorization server to issuer:', issuer);
}

const oktaConfig = {
  issuer: issuer,
  clientId: idpConfig.clientId,
  redirectUri: idpConfig.redirectUri || 'http://localhost:3000/login/callback',
  scopes: (idpConfig.scope || 'openid profile email').split(' '),
  pkce: true, // Enable PKCE for authorization code flow
  responseType: 'code', // Use authorization code flow
  responseMode: 'query', // Code in query params
  // Additional configuration for better compatibility
  tokenManager: {
    autoRenew: true,
    secure: false // Set to false for localhost development
  },
  // Ensure proper token handling
  storageManager: {
    token: {
      storageTypes: ['localStorage']
    }
  },
  // Restore original URI after authentication
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    logger.debug('[OKTA-CONFIG] Restoring original URI:', originalUri);

    try {
      // Get user info and save to localStorage BEFORE redirecting
      const user = await oktaAuth.getUser();
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('isAuthenticated', 'true');
        logger.debug('[OKTA-CONFIG] User info saved to localStorage:', user.email);
      }
    } catch (err) {
      logger.warn('[OKTA-CONFIG] Error saving user info:', err);
    }

    // Now redirect to home page or original URI
    window.location.replace(originalUri || '/');
  }
};

logger.debug('[OKTA-CONFIG] Okta Configuration:', {
  issuer: oktaConfig.issuer,
  clientId: oktaConfig.clientId,
  redirectUri: oktaConfig.redirectUri,
  scopes: oktaConfig.scopes
});

const oktaAuth = new OktaAuth(oktaConfig);

// Start the OktaAuth service
oktaAuth.start().catch(err => {
  logger.error('[OKTA-CONFIG] Failed to start OktaAuth:', err);
});

export default oktaAuth;
